module.exports = __webpack_public_path__ + "static/4-954f23695e060af2fe50351489837a01.jpg";